import { render, staticRenderFns } from "./Daftar.vue?vue&type=template&id=55b25dc9&"
import script from "./Daftar.vue?vue&type=script&lang=js&"
export * from "./Daftar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports